<template>
  <div class="hero-foot" :style="{ height }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  componentName: 'Footer',
  props: {
    height: {
      type: String,
      default: 'auto'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/Footer.vue